/* eslint-disable camelcase */
import React from "react";
import Table from "components/Table/Table";
import { withQuery } from "containers/withQuery";
import styled from "styled-components";
import { compose } from "react-apollo";
import { httpClient } from "settings/apolloClient";
import { withConcreteFormulaIdsConsumer } from "contexts/ConcreateFormulaIdsContext/ConcreteFormulaIdsContext";
import Switch from "react-bootstrap-switch";
import { CONCRETE_FORMULAS_QUERY } from "./FamiliesAndFormulasQueries";
import { UPDATE_CONCRETE_FORMULA_MUTATION } from "./ConcreteTracesModal/concreteFormulaMutations.js";
import CONCRETE_FORMULA_QUERY, { SUPPLIERS_QUERY } from "./ConcreteTracesModal/concreteFormulaQueries.js";
import CardHeader from "./CardHeader";
import ConcreteTracesModal from "./ConcreteTracesModal/ConcreteTracesModal.jsx";
import ConcreteFormulaCopyCreate from "./ConcreteTracesModal/ConcreteFormulaCopyCreate.jsx";

const Icon = styled.i`
  cursor: pointer;
  font-size: 30px;
  color: #2484C6;
`;


const headers = [
  {
    label: "Código", key: "code",
  },
  {
    label: "FCK", key: "fck",
  },
  {
    label: "Consumo", key: "consumption",
  },
  {
    label: "Fator A/C", key: "wcRatio",
  },
  {
    label: "Visualizar", key: "editButton",
  },
  {
    label: "Ativo", key: "activeSwitch",
  },
  {
    label: "Copiar", key: "copyButton",
  }
];


export const renderTag = ({
  id,
  name,
}) => (
  <div
    key={id}
    style={{
      backgroundColor: "#1D84C6",
      color: "white",
      borderRadius: "20px",
      marginRight: "15px",
      marginLeft: "10px",
      padding: "5px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: "80px"
    }}
  >
    {name}
  </div>
);

class FormulasTable extends React.Component {
  state = {
    filterText: "",
    modalOpen: false,
    selected: null,
    copied: null,
    updatingFormulaId: null,
  }

  componentDidMount () {
    const { refetch } = this.props;
    this.props.concreteFormulaIdsContext.setRefetch(refetch);
    httpClient.query({
      query: SUPPLIERS_QUERY,
    }).then(({ data }) => {
      this.setState({ suppliers: data.suppliers });
    });
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.concreteFamiliesSelected !== this.props.concreteFamiliesSelected) {
      this.props.concreteFormulaIdsContext.setRefetch(nextProps.refetch);
    }
  }

  componentWillUnmount () {
    this.props.concreteFormulaIdsContext.resetState();
  }

  mapDataToTable = concreteFormulas => concreteFormulas.map(({
    id, code, fck, use, consumption, wcRatio, version, price, is_active
  }) => ({
    id,
    code,
    fck,
    use,
    consumption,
    wcRatio: parseFloat(wcRatio).toFixed(2),
    version,
    price: parseFloat(price).toFixed(2),
    editButton: (
      <Icon className="far fa-eye" onClick={() => this.selectModalTrace(id)} />
    ),
    copyButton: (
      <Icon className="far fa-copy" onClick={() => this.selectCopyCreateModal(id)} />
    ),
    activeSwitch: (
      <Switch
        offColor="info"
        offText=""
        onColor="info"
        onText=""
        value={is_active}
        onChange={this.onChangeActiveSwitch(id)}
        disabled={this.state.updatingFormulaId === id}
        style={{ marginBottom: "0px" }}
        width="100px"
      />
    ),
  }));

  onChangeFamilyValue = e => this.setState(({ filterText: e.target.value || "" }));

  closeModalHandler = () => this.setState({ modalOpen: false, selected: null, copied: null });

  selectModalTrace = id => this.setState({ modalOpen: true, selected: id });

  selectCopyCreateModal = id => this.setState({ modalOpen: true, copied: id });

  onChangeActiveSwitch = id => async el => {
    const nextIsActive = el.value();

    try {
      this.setState({ updatingFormulaId: id });

      const { data } = await httpClient.query({
        query: CONCRETE_FORMULA_QUERY,
        variables: { id },
        fetchPolicy: "network-only",
      });

      const formula = data && data.concreteFormula;

      if (!formula) {
        throw new Error(`Fórmula ${id} not found.`);
      }

      await httpClient.mutate({
        mutation: UPDATE_CONCRETE_FORMULA_MUTATION,
        variables: {
          id,
          params: {
            code: formula.code,
            use: formula.use,
            concreteFamilyId: formula.concreteFamily.id,
            formulaMaterials: (formula.formulaMaterials || []).map(material => ({
              inventoryItemId: material.inventoryItem.id,
              supplierId: material.supplier ? material.supplier.id : null,
              proportion: material.proportion,
              weight: material.weight,
              specificWeight: material.specificWeight,
              order: material.order,
            })),
            is_active: nextIsActive,
          },
        },
      });

      await this.props.refetch();
    } catch (error) {
      console.error("Error while updating formula status:", error);
    } finally {
      this.setState({ updatingFormulaId: null });
    }
  };

  render() {
    const { filterText, selected, modalOpen, copied } = this.state;
    const { concreteFormulas, concreteFamiliesSelected, showInactiveFormulas } = this.props;

    const dataTable = this.mapDataToTable(concreteFormulas);
    const items = dataTable
      .filter((row) => (
        Object.values(row).some(data => data.toString().match(RegExp(filterText, "i")))
      ));
    const tags = concreteFamiliesSelected.map(renderTag);

    return (
      <React.Fragment>
        {
          (selected) && (
            <ConcreteTracesModal
              id={selected}
              concreteFamilyIds={concreteFamiliesSelected.map(({ id }) => id)}
              closeModalHandler={this.closeModalHandler}
              modalOpen={modalOpen}
              suppliers={this.state.suppliers}
            />
          )
        }
        {
          (copied) && (
            <ConcreteFormulaCopyCreate
              id={copied}
              concreteFamilyIds={concreteFamiliesSelected.map(({ id }) => id)}
              closeModalHandler={this.closeModalHandler}
              modalOpen={modalOpen}
              suppliers={this.state.suppliers}
            />
          )
        }
        <CardHeader
          title={showInactiveFormulas ? "Traços ativos e inativos" : "Traços ativos"}
          tags={tags}
          onChange={this.onChangeFamilyValue}
        />
        <Table tableName="formulas" headers={headers} matchHeaders items={items} />
      </React.Fragment>
    );
  }
}

export default compose(
  withConcreteFormulaIdsConsumer,
  withQuery(({ concreteFamiliesSelected, showInactiveFormulas }) => ({
    query: CONCRETE_FORMULAS_QUERY,
    variables: {
      concreteFamilyIds: concreteFamiliesSelected.map(({ id }) => id),
      is_active: showInactiveFormulas ? null : true,
    },
    fetchPolicy: "network-only",
  })),
)(FormulasTable);
